import { Box, Flex, } from "@chakra-ui/react";
import React from "react";
import SearchWalletLinks from "./SearchWalletLinks";

export default function SearchWallet(props) {
    return (
        <Flex>
            <Flex w="100%" flexDirection={{ sm: "column", md: "row", }} alignItems={{ xl: "center" }} >
                <Box ms="auto" w={{ sm: "100%", md: "unset" }}>
                    <SearchWalletLinks
                        logoText={props.logoText}
                        secondary={props.secondary}
                        fixed={props.fixed}
                        initialValue={props.initialValue}
                        onChange={props.onChange}
                        debounce={props.debounce}
                    />
                </Box>
            </Flex>
        </Flex>
    );
}
